/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { Popover } from 'antd'
import { observer } from 'mobx-react'
import NumberFormat, { NumberFormatValues } from 'react-number-format'
import { size } from 'lodash'
import { isMobile } from 'react-device-detect'
import useRootStore from '@store/useRootStore'
import { PROPERTY_ID } from 'adv-protocol/src/GameCommon'
import {
  formatNumber,
  getRatioTicketMoney,
  getTicketCountFromTicket,
  isKeyInputEnterAndSpaceBar,
  showToast,
  TOAST_TYPE,
} from '@utils/utils'
// image
import BetCouponImg from '@assets/images/icon/matchup_icon/betting-coupon-10000.png'
// icon
import { GmoneyIco } from '@shared/Icon/MoneyIcon'
import checkIco from '@assets/images/icon/matchup_icon/check_icon.png'
import { ArrowIco } from '@shared/Icon/ArrowIcon'
import { BetIco } from '@shared/Icon/MatchupIcon'
import { PopoverIco } from '@shared/Icon/EtcIcon'
// css
import { Button } from '@styles/button.style'
import LiveCount from '@views/Matchup/BetSlip/LiveCount'
import { BET_TICKET_TYPE } from '@constants/index'

import { GAME_TYPE } from '@game-type/game-market-types'
import {
  isInputNotAvailable,
  makeFoldItems,
  setUserInputBetMoney,
  doBet,
  onClickMoneyButton,
  onClickMoneyAllin,
  onClickMoneyReset,
  onShowBetCoupon,
  makeBetMoneyRangeText,
  getRate,
  getHitMoney,
  getPenaltyAppliedRate,
  exchangeMoneyByBetMoneyType,
  maxBetMoneyByBetMoneyType,
} from './BetSlipHelper'
import {
  BetSlipBody,
  BetSlipHeader,
  BetSlipSiderWrap,
  BettingCouponStyle,
  BottomContent,
  CheckboxImg,
  CheckBoxWrapper,
  ContinueBtn,
  DeleteBtnStyle,
  Fold,
  FormStyle,
  NumButton,
  NumButtonWrap,
  SiderBetting,
  TxtColor,
} from './index.style'
import { betSlipPenaltyTxt } from './BetSlipBottom'

// icon
const Gmoney = (
  <span className="gmoney-ico">
    <GmoneyIco/>
  </span>
)

export const usePrevious = (value) => {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

export const getChangeClass = (value) => {
  const prev = usePrevious(value)
  let className = ''
  if (value !== prev) {
    if (value % 2 === 1) {
      className = 'change-odds'
    } else {
      className = 'change-even'
    }
  }
  return className
}

const BetSlipSider: React.FC = () => {
  const [checkedAll, setCheckedAll] = useState(false)
  const { authStore, matchupStore, globalStore, componentStore } = useRootStore()
  const { visibleBetCoupon } = globalStore
  const { userInfo } = authStore
  const { money, ticket, dia } = userInfo
  const {
    orderedCart = [],
    betMoney = 0,
    betMoneyType,
    collapsedBetSlipSider,
    categoryTab,
    sportTab,
    currentGameKey,
    typeOn,
  } = matchupStore
  const { selectedUserExtraOddsItem } = componentStore

  const [updater, setUpdater] = useState(0)

  const targetCart = orderedCart
  const targetBetMoney = betMoney
  const initialBetMoney = targetBetMoney
  const uiInitialBetMoney = betMoneyType === PROPERTY_ID.MONEY ? initialBetMoney : getRatioTicketMoney(initialBetMoney)
  const isSingleBetPenalty = orderedCart.length === 1 && currentGameKey !== GAME_TYPE.LIVE

  const onPriceValueChange = (values: NumberFormatValues) => {
    if (isInputNotAvailable(targetCart)) {
      return
    }
    if (!visibleBetCoupon) {
      if (betMoneyType === PROPERTY_ID.NEW_BET_TICKET_G) {
        matchupStore.setBetMoney(targetBetMoney, betMoneyType)
        setUpdater(updater + 1)
        const moneyInputElem: HTMLInputElement = document.querySelector('#bet_slip_slider_money_input input')
        if (moneyInputElem) {
          moneyInputElem.disabled = true
        }
        // 더 이상 사용하지 않는 다이얼로그
        globalStore.pushDialogYesNo({
          id: 'betTicketInitializeAlertModal',
          title: '알림',
          text: ['G머니를 입력하는 경우', '입력한 베팅권이 초기화 됩니다.', 'G머니로 베팅하시겠습니까?'],
          wrapClassName: 'reset-amount',
          className: 'small-size',
          positivePress: '확인',
          negativePress: '취소',
          callbackPositive: () => {
            setUserInputBetMoney({ value: '0' } as NumberFormatValues, money, updater, setUpdater)
            if (moneyInputElem) {
              moneyInputElem.disabled = false
            }
          },
          callbackNegative: () => {
            if (moneyInputElem) {
              moneyInputElem.disabled = false
            }
          },
        })
      } else {
        let targetUserMoney
        if (betMoneyType === PROPERTY_ID.MONEY) {
          targetUserMoney = money
        } else if (betMoneyType === PROPERTY_ID.DIA) {
          targetUserMoney = dia
        }
        setUserInputBetMoney(values, targetUserMoney, updater, setUpdater)
      }
    }
  }

  const onCheckedChange = (e: string) => {
    matchupStore.toggleCartItem(e)
  }

  const onCheckedAll = () => {
    if (isInputNotAvailable(targetCart)) {
      return
    }
    setCheckedAll(!checkedAll)
    matchupStore.toggleCartItemAll(!checkedAll)
  }

  const deleteChecked = () => {
    if (isInputNotAvailable(targetCart)) {
      return
    }
    const items = matchupStore.getCheckedCartItems()
    if (size(items) === 0) {
      showToast(TOAST_TYPE.INFO, '선택한 폴드가 없습니다.')
      return
    }

    const retCart = matchupStore.deleteCheckedCartItems()
    setCheckedAll(false)
    if (size(retCart) === 0) {
      if (isMobile) {
        matchupStore.toggleBetSlipSiderCollapsed(true)
      }
    }
  }

  let isBet = true
  // NOTE : 베팅후  엔터키나 spacebar를  눌렀을 경우
  //        베팅연사를 막기위한 이벤트
  const onKeyDown = (e) => {
    if (isKeyInputEnterAndSpaceBar(e.keyCode)) {
      isBet = false
    }
  }

  let visible = !isMobile || !collapsedBetSlipSider
  // NOTE: 모바일의 경우 상세베팅에서 배당률 변경시 변경팝업창이 뜨고
  //       프론트 매치로 이동하게되면 collapsedBetSlipSider 값이 false로 되어있어서
  //       cart는 초기화가 되어있는데 betSlipSlider가 나오는 상황.
  //       cart에 베팅정보가 없으면 의미가 없기때문에 slider 스크립트에서 제어
  if (visible && targetCart.length === 0) {
    matchupStore.toggleBetSlipSiderCollapsed(true)
    visible = false
  }

  const rate = isSingleBetPenalty
    ? getPenaltyAppliedRate(targetCart, selectedUserExtraOddsItem?.rate)
    : getRate(targetCart, selectedUserExtraOddsItem?.rate)
  const hitMoney = getHitMoney(targetBetMoney, rate)
  const exchangedHitMoney = exchangeMoneyByBetMoneyType(hitMoney, betMoneyType)

  const foldNum = targetCart.length
  let foldClass = getChangeClass(foldNum)
  let rateClass = getChangeClass(rate)

  const betSlipAniSec = Number(0.5)
  setTimeout(() => {
    if (foldClass !== '') {
      foldClass = ''
      setUpdater(updater + 1)
    }
    if (rateClass !== '') {
      rateClass = ''
      setUpdater(updater + 1)
    }
  }, (betSlipAniSec * 1000))

  const bet_min_max = makeBetMoneyRangeText()

  let foldItems = []
  if (visible) {
    foldItems = makeFoldItems(targetCart, onCheckedChange)
  }

  const handleOnClose = () => {
    matchupStore.toggleBetSlipSiderCollapsed(true)
  }

  const onClickMoneyButtonWrap = (value: number) => {
    const maxBetMoney = maxBetMoneyByBetMoneyType(betMoneyType, typeOn)
    onClickMoneyButton(value, targetCart, targetBetMoney, betMoneyType, money, maxBetMoney)
  }

  let betButtonClassName = 'bottom-btn'
  if (size(foldItems) <= 0) {
    betButtonClassName += ' disabled'
  }

  let betTicketButtonClassName = 'sider-bet-coupon'
  if (!userInfo.ticket || getTicketCountFromTicket(BET_TICKET_TYPE.BET_TICKET1, userInfo.ticket) <= 0) {
    betTicketButtonClassName = 'hide'
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const renderContentsBody = () => {
    return (
      <Fragment>
        <BetSlipSiderWrap className={isMobile ? '' : 'pc-betslip-sider'}>
          <BetSlipHeader>
            <label htmlFor="all" css={CheckBoxWrapper}>
              <input
                type="checkbox"
                id="all"
                checked={checkedAll}
                readOnly
                onClick={onCheckedAll}
                disabled={isInputNotAvailable(targetCart)}
              />
              <span className="check-box-bg">
                <img src={checkIco} alt="체크" css={CheckboxImg} className="all-check"/>
              </span>
            </label>
            <Button css={DeleteBtnStyle} onClick={deleteChecked}>
              <p>선택 삭제</p>
            </Button>
            {isMobile && (
              <Button
                secondary
                className={matchupStore.collapsedBetSlipSider === true ? 'hide' : ''}
                css={ContinueBtn}
                onClick={handleOnClose}
              >
                <span className="btn-txt">
                  베팅
                <br/>
                  계속
              </span>
                <ArrowIco/>
              </Button>
            )}
            <Fold className="bet-sider-fold">
              <span className="txt">폴드</span>
              <span className={`num betslip-ani fold ${foldClass} ${rateClass}`}>
                <span className="ani-num">{size(foldItems)}</span>
              </span>
            </Fold>
          </BetSlipHeader>

          <form name="betlist" css={FormStyle} className={isMobile ? '' : 'pc-betslip-sider-list'}>
            {foldItems}
          </form>

          <BottomContent className={isMobile ? '' : 'pc'}>
            <BetSlipBody>
              <ul className="money-wrap">
                <li className="money-list">
                  <span css={TxtColor}>1회 베팅한도</span>
                  <span className="right-txt">
                    {bet_min_max}
                    {Gmoney}
                  </span>
                </li>
                <li className="money-list">
                  <span css={TxtColor}>보유머니</span>
                  <span className="right-txt ">
                    {formatNumber(money)}
                    {Gmoney}
                  </span>
                </li>
              </ul>

              <NumButtonWrap className="sider">
                <NumButton className="sider-num-btn" onClick={() => {
                  onClickMoneyButtonWrap(500000)
                }}>
                  <span className="money-btn-wrap">500,000<GmoneyIco/></span>
                </NumButton>
                <NumButton className="sider-num-btn" onClick={() => {
                  onClickMoneyButtonWrap(100000)
                }}><span className="money-btn-wrap">100,000<GmoneyIco/></span></NumButton>
                <NumButton className="other sider-num-btn" onClick={() => {
                  let targetUserMoney
                  if (betMoneyType === PROPERTY_ID.MONEY) {
                    targetUserMoney = money
                  } else if (betMoneyType === PROPERTY_ID.DIA) {
                    targetUserMoney = dia
                  }
                  const maxBetMoney = maxBetMoneyByBetMoneyType(betMoneyType, typeOn)
                  onClickMoneyAllin(targetCart, targetUserMoney, maxBetMoney)
                }}>
                  올인
                </NumButton>
                <NumButton className="sider-num-btn" onClick={() => {
                  onClickMoneyButtonWrap(10000)
                }}><span className="money-btn-wrap">10,000<GmoneyIco/></span></NumButton>
                <NumButton className="sider-num-btn" onClick={() => {
                  onClickMoneyButtonWrap(1000)
                }}><span
                  className="money-btn-wrap">1,000<GmoneyIco/></span></NumButton>
                <NumButton className="other sider-num-btn" onClick={() => {
                  onClickMoneyReset()
                }}>
                  초기화
                </NumButton>
                <div className="money-input-wrap sider" id="bet_slip_slider_money_input">
                  <NumberFormat
                    pattern="\d*"
                    decimalScale={0}
                    maxLength={20}
                    allowNegative={false}
                    value={uiInitialBetMoney || ''}
                    thousandSeparator
                    onValueChange={onPriceValueChange}
                    disabled={isInputNotAvailable(targetCart) || (betMoneyType === PROPERTY_ID.MONEY && money <= 0)}
                  />
                  {Gmoney}
                </div>
                <Button css={BettingCouponStyle} className={betTicketButtonClassName} onClick={() => {
                  if (isInputNotAvailable(targetCart)) {
                    return
                  }
                  onShowBetCoupon(ticket, targetBetMoney, betMoneyType)
                }}>
                  <img src={BetCouponImg} alt="베팅권"/>
                  <span>베팅권</span>
                </Button>
              </NumButtonWrap>
              <div className="betslip-top-wrap">
                <div className="betslip-top-wrap--info fold">
                  <span className="betslip-top-wrap--info--txt">폴드</span>
                  <span className={`betslip-top-wrap--info--num betslip-ani fold ${foldClass} ${rateClass}`} style={{ animationDuration: `${betSlipAniSec}s` }}>
                    {isMobile ? <span className="betslip-ani--bg big" style={{ animationDuration: `${betSlipAniSec}s` }}/> : <span className="betslip-ani--bg pc" style={{ animationDuration: '5s' }}/>}
                    <span className="ani-num" style={{ animationDuration: `${betSlipAniSec}s` }}>{foldNum}</span>
                  </span>
                </div>
                <div className="betslip-top-wrap--info rate">
                  {/* 싱글 페널티 */}
                  {/* 백스크롤 발생시 popover의 위치가 변경되는 현상이 발생하여 position: 'fixed' 추가 */}
                  {isSingleBetPenalty ?
                    <Popover placement="topRight" content={betSlipPenaltyTxt} trigger={isMobile ? 'click' : 'hover'} overlayStyle={{ position: 'fixed' }}>
                      <Button className="tooltip-btn bet-slip sider">
                      <span className="betslip-top-wrap--info--txt">
                        배당
                      </span>
                        <PopoverIco/>
                      </Button>
                    </Popover> :
                    <span className="betslip-top-wrap--info--txt original-code">배당</span>
                  }
                  <span className="betslip-top-wrap--info--num rate">
                    <span className="ani-num">{rate === 0 ? 0 : rate.toFixed(2)}</span>
                  </span>
                </div>
              </div>

              <div className="money-list dividend-money">
                <span css={TxtColor}>예상 적중머니</span>
                <span className="right-txt">
                  {formatNumber(exchangedHitMoney)}
                  {Gmoney}
                  </span>
              </div>
            </BetSlipBody>
            <Button secondary css={SiderBetting} onClick={(e) => {
              e.currentTarget.blur()

              if (isBet === false) {
                isBet = true
                return
              }
              doBet(targetCart, categoryTab, sportTab, '#bet_slip_slider_money_input input', rate)
            }} className={betButtonClassName} onKeyDown={onKeyDown}>
              <BetIco/>
              베팅하기
            </Button>
          </BottomContent>
        </BetSlipSiderWrap>
        {isMobile && <LiveCount key="Matchup:LiveCount" matchupStore={matchupStore} globalStore={globalStore}/>}
      </Fragment>
    )
  }

  const renderContents = () => {
    // let contents
    // if (isMobile) {
    //   contents = (
    //     <Drawer
    //       mask={false}
    //       placement="left"
    //       className="bet-slip"
    //       width="100%"
    //       height="100%"
    //       visible={visible}
    //       onClose={handleOnClose}
    //       bodyStyle={{ padding: '0', height: '100%' }}
    //       closable={false}
    //       css={BetSiderStyle}
    //     >
    //       {renderContentsBody()}
    //     </Drawer>
    //   )
    // } else {
    //   contents = renderContentsBody()
    // }
    //
    // return (
    //   <Fragment>
    //     {/*{contents}*/}
    //   </Fragment>
    // )
    return null
  }

  return renderContents()
}

export default observer(BetSlipSider)
